// extracted by mini-css-extract-plugin
export default {"productDescription":"S_-z","featuredDescription":"T_-z","description":"U_-z","more":"V_-z","descriptionSku":"W_-z"};